var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-groups" }, [
    _c(
      "div",
      { staticClass: "m-5" },
      [
        _c(
          "a-table",
          {
            key: "vtable-" + _vm.renderCount,
            staticClass: "customer-groups-table",
            attrs: {
              rowKey: "_id",
              columns: _vm.columns,
              dataSource: _vm.getItems(),
              pagination: _vm.pagination,
              customRow: function (record) {
                return {
                  props: {},
                  on: {
                    mouseover: function (event) {
                      _vm.rowMouseOver(record)
                    },
                    mouseleave: function (event) {
                      _vm.rowMouseLeave(record)
                    },
                    click: function (event) {
                      _vm.rowClicked(record)
                    },
                  },
                }
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "avatar",
                fn: function (text, record) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "customer-group-avatar text-center",
                        class: {
                          "customer-group-avatar-odd": record.index % 2 === 0,
                        },
                      },
                      [
                        _c(
                          "md-highlight-text",
                          {
                            staticClass: "text-center",
                            attrs: { "md-term": "term" },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(record.name.slice(0, 2).toUpperCase()) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "contacts",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$_.get(record, "contacts.length", 0)
                            ? _vm.$_.get(record, "contacts.length", 0) + " User"
                            : _vm.$t("wp.noContactFound")
                        )
                    ),
                  ])
                },
              },
              {
                key: "description",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(_vm.$_.get(record, "description", "-"))),
                  ])
                },
              },
              {
                key: "operation",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {
                      staticClass:
                        "d-flex flex-row justify-content-end operation-buttons",
                      class: { hidden: _vm.selectedRowId !== record._id },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "material-icons mx-2 text-primary operation-button",
                          on: {
                            click: function (e) {
                              return _vm.onEdit(e, record)
                            },
                          },
                        },
                        [_vm._v("\n                    edit\n                ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "material-icons mx-2 text-danger operation-button",
                          on: {
                            click: function (e) {
                              return _vm.showConfirm(e, record)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    delete\n                "
                          ),
                        ]
                      ),
                    ]
                  )
                },
              },
            ]),
          },
          [
            _c("span", { attrs: { slot: "indexTitle" }, slot: "indexTitle" }, [
              _vm._v(" # "),
            ]),
            _vm._v(" "),
            _c("span", { attrs: { slot: "nameTitle" }, slot: "nameTitle" }, [
              _vm._v(" " + _vm._s(_vm.$t("wp.name")) + " "),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { attrs: { slot: "descriptionTitle" }, slot: "descriptionTitle" },
              [_vm._v(_vm._s(_vm.$t("wp.description")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              { attrs: { slot: "contactsTitle" }, slot: "contactsTitle" },
              [_vm._v(_vm._s(_vm.$t("wp.contacts")))]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }